import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CurrencyChanger, CustomNavBar } from "../../../components";
import { getCurrency } from "../../../plugins/utils";
const Navigation = (params) => {
  const [showCurrencyChanger, setShowCurrencyChanger] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const nowCurrency = getCurrency();
  const rightContentRender = () => (
    <div
      onClick={() => {
        setShowCurrencyChanger(true);
      }}
      style={{ color: "var(--nav-topbar-text)" }}
    >
      {t("navBar.currency")}
      <span style={{ color: "var(--nav-topbar-link)" }}>{nowCurrency}</span>
    </div>
  );
  return (
    <>
      <CustomNavBar
        {...params}
        onBack={() => {
          navigate(params.backUrl ?? "/home");
        }}
        right={params.hideCurrencyCahnger ? "" : rightContentRender()}
      >
        {t(params.title)}
      </CustomNavBar>
      <CurrencyChanger
        visible={showCurrencyChanger}
        onClose={() => {
          setShowCurrencyChanger(false);
        }}
      />
    </>
  );
};

export default Navigation;
